"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelService = void 0;
const HttpRequest_1 = require("../HttpRequest");
exports.modelService = {
    list(auth, assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new HttpRequest_1.HttpRequest().get("/assets/" + assetId + "/models?version=" + auth.assetVersionType.toString(), auth.token);
        });
    },
    get(auth, assetId, modelId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new HttpRequest_1.HttpRequest().get("/assets/" + assetId + "/models/" + modelId + "?version=" + auth.assetVersionType.toString(), auth.token);
        });
    },
    getPreviewUrl(auth, assetId, modelId, qualityType) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new HttpRequest_1.HttpRequest().get("/assets/" + assetId + "/models/" + modelId + "/preview-url?resolution=" + qualityType + "&version=" + auth.assetVersionType.toString(), auth.token);
        });
    }
};
